import { render, staticRenderFns } from "./SpeakersSection.vue?vue&type=template&id=041cf85f&"
import script from "./SpeakersSection.vue?vue&type=script&lang=js&"
export * from "./SpeakersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports